if (!customElements.get('whw-size-guide')) {
  customElements.define('whw-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-whw-guide-open]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.opener.hidden = false;
      this.opener.addEventListener('click', () => this.dialog.showModal(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.opener.focus(), options);
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  });
}

if (!customElements.get('whw-sticky-purchase')) {
  customElements.define('whw-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.product = this.closest('product-info');
      this.info = this.product?.querySelector('.product__info-container');
      this.form = document.getElementById(this.dataset.formId);
      this.source = this.form?.querySelector('[name="add"]');
      this.button = this.querySelector('button');
      if (!this.info || !this.source || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value'] });
      this.product.addEventListener('change', this.sync, options);
      this.button.addEventListener('click', (event) => {
        this.sync();
        if (this.button.disabled) event.preventDefault();
        else this.submittedHere = true;
      }, options);
      this.visibility = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.visibility.observe(this.source);
      this.sync();
    }

    sync() {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true' || !variantId;
      this.button.disabled = disabled;
      this.button.textContent = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
      this.button.setAttribute('aria-busy', String(this.source.classList.contains('loading')));
      const selectedOptions = [...this.info.querySelectorAll('variant-selects input:checked, variant-selects option:checked')].map((input) => input.value);
      this.querySelector('[data-whw-sticky-variant]').textContent = selectedOptions.join(' / ') || this.dataset.productTitle;
      const price = this.info.querySelector('.price--on-sale .price-item--sale') || this.info.querySelector('.price__regular .price-item--regular');
      this.querySelector('[data-whw-sticky-price]').textContent = variantId ? price?.textContent.trim() || '' : '';
      if (this.source.hasAttribute('aria-haspopup')) this.button.setAttribute('aria-haspopup', this.source.getAttribute('aria-haspopup'));
      else this.button.removeAttribute('aria-haspopup');
      const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (error && this.submittedHere) {
        this.submittedHere = false;
        error.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.observer?.disconnect();
      this.visibility?.disconnect();
    }
  });
}
